import { selectActivityFilterGridData } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Row = {
    activity: string;
    tasks: number;
};

export type GridRow = Row & { id: number }

export type SetActivitySlicerSelectedDataProps = ApiMethodBase & {
    selection: Row[];
};

export const setActivityFilterSelectedData = ({
    selection,
}: SetActivitySlicerSelectedDataProps) => {
    selectActivityFilterGridData(selection);
};
